import React, { ComponentState, useEffect, useState } from 'react';
import { ResponsiveContainer } from 'recharts';
import { Paper, Typography, Tooltip as MuiTooltip, Tooltip } from '@mui/material';
import { useSelector } from "react-redux";
import { PieChart,pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { pieChartModel } from 'src/dataModels/docListModel';

export const DocumentByStatus = () => {
    const state: ComponentState = useSelector(states => {
        return states;
    });

    const [billingData, setBillingData] = useState<pieChartModel[]>([])
    const { documentBillingByStatus } = state['DocumentReducer'];
    useEffect(() => {
        setBillingData([]);
        if (documentBillingByStatus && documentBillingByStatus?.resultData) {
            documentBillingByStatus?.resultData?.map((element, index) => {
                const totalBillValue = Number(element?.totalBilled?element?.totalBilled:0).toFixed(2);
                const formattedTotalBill = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(Number(totalBillValue));

                const label = `Docs:${element?.totDocs}`
                var obj: pieChartModel = {
                    id: index, 
                    label: `${element?.documentStatus}`, 
                    value: element?.totDocs,
                    // color: element?.color, 
                    info: label,
                    totalBilled: formattedTotalBill,
                    count: element?.totDocs
                }
                setBillingData(oldArray => [...oldArray, obj]);
            })
        }
    }, [documentBillingByStatus])


    const mostDocumentsBilling = billingData[0];
    const totalValue = billingData.reduce((sum, item) => sum + item.count, 0);
    const CustomItemTooltipContent = (props) => {
        const { itemData, series } = props;
        const dataIndex= itemData.dataIndex
        const seriesItem= series.data[dataIndex];
        var circleStyle = {
            display:"inline-block",
            backgroundColor: seriesItem.color,
            borderRadius: "50%",
            width:20,
            height:20,
          };
          const docsMatch = seriesItem.info.match(/Docs:(\d+)/);
          const docsValue = docsMatch ? docsMatch[1] : "N/A";
        return (
          <Paper sx={{paddingTop:2,paddingLeft:4,paddingRight:4}}>
            <div className='row'>
            <div style={circleStyle}/><div className='ml-1'><p>{seriesItem.label+' (' + docsValue + ' Documents)'}</p></div>
           </div>
          </Paper>
        );
      };

    return (
        <>
            <div style={{ marginTop: 20 }}>
            {
                documentBillingByStatus?.resultData != 0 ?

                    <Paper elevation={3} style={{ padding: '20px 0' }}>
                        {/* <ChartsTooltip title={totalBilled}> */}
                        <Typography variant="h6" style={{ fontSize: 15 }}>
                            Documents by Document Status:  ({totalValue})
                        </Typography>
                        <ResponsiveContainer width="95%" height={375}>
                            <PieChart
                                series={[
                                    {
                                        arcLabel: (item: any) => {
                                            const percentage = ((item.value / totalValue) * 100).toFixed(2);
                                            return `${percentage}%`;
                                        },
                                        arcLabelMinAngle: 45,
                                        data: billingData,
                                    },
                                ]}
                                width={600}
                                height={400}

                                sx={{
                                    [`& .${pieArcLabelClasses.root}`]: {
                                        fill: 'white',
                                        fontWeight: 'normal',
                                    },
                                }}

                               
                                tooltip={{ trigger: "item", itemContent: CustomItemTooltipContent }}
                                
                                slotProps={{
                                    legend: {
                                      direction: 'column',
                                      labelStyle: {
                                        fontSize: 12,
                                    
                                      },
                                      position: {
                                        vertical: 'middle',
                                        horizontal: 'right',
                                      },
                                      itemMarkWidth: 12,
                                      itemMarkHeight: 12,
                                      markGap: 5,
                                      itemGap: 10,
                                    }
                                  }}
                            >
                               
                            </PieChart>

                        </ResponsiveContainer>
                        {/* </ChartsTooltip> */}
                    </Paper>
                    : ""
            }
            </div>
        </>
    );
};

export default DocumentByStatus;





